import React from 'react';
import styled, { css } from 'styled-components';
import CtaText from 'components/ui/CtaCard';
import { getTranslatedString } from 'helpers/i18n';
import StatusTag from 'components/ui/StatusTag';

let StyledHeaderContainer = styled.div`
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : '#fff')};
  width: 100%;
  padding: 24px;
  display: flex;
  border-bottom: ${props => (props.noBorder ? 'none' : '1px solid #e6e6f0')};
  align-items: center;
`;

const NavLink = styled(CtaText)`
  flex-grow: 1;
  padding: 0;
`;

const StyledBack = styled(NavLink)`
  text-align: left;
`;

const StyledClose = styled(NavLink)`
  text-align: right;
`;

const StyledSubtitle = styled.p`
  margin: 0px;
`;

const Title = styled.div`
  width: 100%;
  font-family: 'Circular-Bold';
  font-size: 1.75rem;

  ${props =>
    props.centerAligned &&
    css`
      text-align: center;
    `};
`;

const StyledTitleContainer = styled.div`
  ${props =>
    props.centerAligned &&
    css`
      text-align: center;
    `};
`;

export default props => {
  if (props.tabbedHeaderStyle) {
    StyledHeaderContainer = styled(StyledHeaderContainer)`
      border-bottom: none;
    `;
  }

  return (
    <StyledHeaderContainer noBorder={props.noBorder} backgroundColor={props.backgroundColor}>
      {!!props.onBack && (
        <StyledBack type="button" onClick={props.onBack}>
          {getTranslatedString('drawerHeader.back')}
        </StyledBack>
      )}
      <StyledTitleContainer centerAligned={!!props.onBack}>
        {!!props.subTitle && <StyledSubtitle>{props.subTitle}</StyledSubtitle>}
        <Title centerAligned={!!props.onBack}>{props.title}</Title>
        {!!props.status && <StatusTag status={props.status} />}
        {!!props.subHeader && <StyledSubtitle>{props.subHeader}</StyledSubtitle>}
      </StyledTitleContainer>
      <StyledClose type="button" onClick={props.onClose}>
        {props.closeVerbiage ? props.closeVerbiage : getTranslatedString('drawerHeader.close')}
      </StyledClose>
    </StyledHeaderContainer>
  );
};
